import { Link } from "react-router-dom";

const TopCollectionCard = ({collection, number}) => {
    return (
        <Link to = {`/collection/${collection.name}`} className="hover:shadow-shadow3">
            <div className="collection_card flex justify-between w-full py-5 border-b-[1px] border-gray-400 dark:border-gray-700 px-2">

                <div className="flex">
                    <div className="flex items-center mr-4">
                        <p className="text-base font-[500]">{number}</p>
                    </div>
                    <div className="flex flex-row items-center">

                        <img src = {collection.image} alt = 'collectioncard' className="rounded-[50%] h-full w-full max-w-[50px] max-h-[50px] md:max-h-[100px] md:max-w-100px collection_card_image mr-4"/>
                        <div className='flex flex-col justify-center'>
                            <p className='text-base  whitespace-nowrap overflow-x-hidden'>
                                {collection.name}
                            </p>
                            <p className='text-sm text-slate-400 font-[500]'>
                                Floor Price: {collection.price}
                            </p>
                        </div>

                    </div>
                </div>

                <div className="flex flex-col justify-end">
                    <p className="text-sm md:text-base text-green-500 mb-1">+24.5%</p>
                    <p className="text-sm md:text-base text-slate-400 font-[500] mb-1">{collection.volume}</p>
                </div>

            </div>
        
        </Link>
    )
}

export default TopCollectionCard;